module.exports = "<div class=\"ticket-fields-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <blnd-upload-section ng-model=\"vm.ticket\" type=\"ticket\"></blnd-upload-section>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/templates/detail.files.html
// module id = 688
// module chunks = 0